import {ModuleWithProviders, NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {DxNciService} from "./services/dx-nci.service";


/**
 * Сервисная часть для работы со справочнками НСИ.
 * Модуль должен импортироваться один раз на уровне рута приложения.
 */
@NgModule({
  declarations: [],
  exports: [],
  imports: [
    CommonModule,
    FormsModule
  ],
  providers: [
    DxNciService
  ],
  bootstrap: []
})
export class DxNciCoreModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: DxNciCoreModule,
      providers: [
        DxNciService
      ]
    };
  }
}
